var _circle, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSoundImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "url(#paint0_linear_1157_2998)",
    strokeOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 23.75C12.1583 23.75 11.875 23.4667 11.875 23.125V16.875C11.875 16.5333 12.1583 16.25 12.5 16.25C12.8417 16.25 13.125 16.5333 13.125 16.875V23.125C13.125 23.4667 12.8417 23.75 12.5 23.75Z",
    fill: "#EF4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.25 25.8332C15.9083 25.8332 15.625 25.5498 15.625 25.2082V14.7915C15.625 14.4498 15.9083 14.1665 16.25 14.1665C16.5917 14.1665 16.875 14.4498 16.875 14.7915V25.2082C16.875 25.5498 16.5917 25.8332 16.25 25.8332Z",
    fill: "#EF4444"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 27.9168C19.6583 27.9168 19.375 27.6335 19.375 27.2918V12.7085C19.375 12.3668 19.6583 12.0835 20 12.0835C20.3417 12.0835 20.625 12.3668 20.625 12.7085V27.2918C20.625 27.6335 20.3417 27.9168 20 27.9168Z",
    fill: "#EF4444"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.75 25.8332C23.4083 25.8332 23.125 25.5498 23.125 25.2082V14.7915C23.125 14.4498 23.4083 14.1665 23.75 14.1665C24.0917 14.1665 24.375 14.4498 24.375 14.7915V25.2082C24.375 25.5498 24.0917 25.8332 23.75 25.8332Z",
    fill: "#EF4444"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 23.75C27.1583 23.75 26.875 23.4667 26.875 23.125V16.875C26.875 16.5333 27.1583 16.25 27.5 16.25C27.8417 16.25 28.125 16.5333 28.125 16.875V23.125C28.125 23.4667 27.8417 23.75 27.5 23.75Z",
    fill: "#EF4444"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1157_2998",
    x1: 20,
    y1: 0,
    x2: 20,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundImg);
export default __webpack_public_path__ + "static/media/soundImg.dae01e2b3cda85ccd0f613355295e5cc.svg";
export { ForwardRef as ReactComponent };